/**
 *  Standard paging composition for organizations
 */
import organizationActionCreators from '../../../actions/organizationActionCreators';
import pagingComposition from '../../common/pagingTable/pagingComposition';
export default pagingComposition(
// these are specific to documents.
'organization',
// these describe the column to attribute mapping.  this is used for
// sending sorting queries to the server.
organizationActionCreators, {
  Name: 'name'
});